import { useMessageStore } from "@/state/stores";
import { BrainIcon, CheckIcon } from "lucide-react";
import { useShallow } from "zustand/shallow";

interface VersionItemProps {
  version: number;
  isActive: boolean;
  isLatest: boolean;
}

export function VersionItem({ version, isActive, isLatest }: VersionItemProps) {
  const versionInformation = useMessageStore(
    useShallow((state) => state.versionInformation),
  );

  // Get current and previous version info
  const currentVersionInfo = Object.values(versionInformation).find(
    (v) => v.version === version,
  );
  const previousVersionInfo = Object.values(versionInformation).find(
    (v) => v.version === version - 1,
  );

  // Check if spec has changed by comparing specId
  const hasSpecChanged = (() => {
    if (!currentVersionInfo?.spec?.id) {
      return false;
    }

    if (!previousVersionInfo?.spec?.id) {
      // If there's no previous version or no previous spec, consider it changed
      return true;
    }

    // Compare specId to detect changes
    return currentVersionInfo.spec.id !== previousVersionInfo.spec.id;
  })();

  return (
    <div className="flex items-center justify-between w-full">
      <span>v{version}</span>
      <div className="flex items-center gap-1 ml-2">
        {hasSpecChanged && <BrainIcon className="w-3 h-3 text-blue-500" />}
        {isLatest && (
          <span className="text-xs text-muted-foreground">(latest)</span>
        )}
        {isActive && <CheckIcon className="w-4 h-4" />}
      </div>
    </div>
  );
}
